import { CredentialStatus } from '@seek/ca-myprofile-utils';

import {
  Actions as LicenceActions,
  type LicenceAction,
} from 'src/components/Profile/Licences/actions';
import type { GraphqlLicence } from 'src/components/Profile/Licences/types';
import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';
import { getVerificationStatus } from 'src/middlewares/utils';
import type { AnalyticsLicenceInfo } from 'src/modules/analytics/types';
import type { ActionName } from 'src/types';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const getAnalyticsLicenceInfo = (
  licence: GraphqlLicence,
): AnalyticsLicenceInfo => ({
  verificationStatus: getVerificationStatus(licence),
  isExpired: licence?.status === CredentialStatus.Expired,
});

const currentPageSection = 'licence';

export const createLicencesAnalyticsMiddleware = (analytics: Analytics) =>
  instrumentAnalytics(analytics) &&
  (() => (next: (action: LicenceAction) => void) => (action: LicenceAction) => {
    const { updateCard } = analytics;

    switch (action.type) {
      case LicenceActions.UPDATE_LICENCE_SUCCESS: {
        const { meta: { analytics: analyticsParams } = {} } = action;
        const actionName = analyticsParams?.actionName as ActionName;
        const actionOrigin = analyticsParams?.actionOrigin;

        if (actionName) {
          updateCard({
            actionName,
            currentPageSection,
            actionOrigin,
          });
        }

        break;
      }

      case LicenceActions.REMOVE_LICENCE_START: {
        const actionName = action.actionName;

        updateCard({
          actionName,
          currentPageSection,
        });

        break;
      }

      case LicenceActions.UPDATE_VERIFIED_LICENCE_SUCCESS: {
        updateCard({
          actionName: 'EDIT',
          currentPageSection,
        });
        break;
      }

      default: {
        break;
      }
    }

    return next(action);
  });
